/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DirectiveListResponse = zod
	.array(
		zod
			.object({
				description: zod.string().nullable().describe('Directive description'),
				id: zod.string().describe('Directive ID'),
				inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
				key: zod.string().describe('Unique key for the directive within the organization'),
				name: zod.string().describe('Directive name'),
				organization_id: zod.string().describe('Organization ID'),
				source: zod.enum(['builtin', 'custom']),
				updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
			})
			.describe('A reusable punishment template')
	)
	.describe('List of directives');

export type DirectiveListResponse = zod.input<typeof DirectiveListResponse>;
export type DirectiveListResponseOutput = zod.output<typeof DirectiveListResponse>;
